import { Box, Grid, List, Stack, styled } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { FieldValues, FormProvider, SubmitHandler, useFormContext } from 'react-hook-form';
import { TechFetchSearch } from 'wisestep-api';
import { IFilterList, WsButton, WsDrawer } from 'wisestep-base';

import CheckboxListFilter from '../../../../components/filters/components/CheckboxListFilter';
import BasicSearchForm from '../../types/IBasicSearchForm';

import SelectFilters from './SelectFilter';

interface AdvanceFilterProps {
  open: boolean;
  onClose: () => void;
  performSearch: (values: BasicSearchForm & TechFetchSearch) => void;
  setFilterTags: Dispatch<SetStateAction<IFilterList[]>>;
}

const DrawerFooter = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
  position: 'fixed',
  bottom: 1,
  left: 2,
  right: 2,
  justifyContent: 'flex-end',
}));

const AdvanceFilter = ({ open, onClose, performSearch }: AdvanceFilterProps) => {
  const methods = useFormContext();
  const { handleSubmit, reset } = methods;

  return (
    <FormProvider {...methods}>
      <WsDrawer
        title="Advanced Filters"
        open={open}
        onClose={() => onClose()}
        size="medium"
        headerSize="medium"
      >
        <Box
          component="form"
          role="presentation"
          onSubmit={handleSubmit(performSearch as SubmitHandler<FieldValues>)}
          onReset={() => reset()}
        >
          <Box pb={7}>
            <List>
              <SelectFilters
                name="allAny"
                title="Search Pattern"
                selectArray={[
                  {
                    label: 'Select',
                    value: '',
                  },
                  {
                    label: 'Match All Keywords',
                    value: 'All',
                  },
                  {
                    label: 'Match Any Keyword',
                    value: 'Any',
                  },
                ]}
              />
              <SelectFilters
                name="willingToRelocate"
                title="Willing to Relocate"
                selectArray={[
                  {
                    label: 'Select',
                    value: '',
                  },
                  {
                    label: 'Yes',
                    value: 'Yes',
                  },
                  {
                    label: 'No',
                    value: 'No',
                  },
                ]}
              />
              <CheckboxListFilter
                name="workAuthorizations"
                options={{
                  'US Citizen': 'US Citizen',
                  'Green Card': 'Green Card',
                  'H1B Work Permit': 'H1B Work Permit',
                  'OPT EAD': 'OPT EAD',
                  'CPT EAD': 'CPT EAD',
                  'GC EAD': 'GC EAD',
                  'L2 EAD': 'L2 EAD',
                  'H4 EAD': 'H4 EAD',
                  'TN EAD': 'TN EAD',
                }}
                title="Work Authorization"
              />

              <CheckboxListFilter
                name="experiences"
                options={{
                  Any: 'Any',
                  Junior: 'Junior',
                  Middle: 'Middle',
                  Senior: 'Senior',
                  Architect: 'Architect',
                }}
                title="Experience"
              />

              <CheckboxListFilter
                name="degrees"
                options={{
                  PreBachelor: 'PreBachelor',
                  Bachelor: 'Bachelor',
                  Master: 'Master',
                  Doctorate: 'Doctorate',
                }}
                title="Degree"
              />

              <CheckboxListFilter
                name="preferredEmploymentTypes"
                options={{
                  'Corp-Corp': 'Corp-Corp',
                  'W2-Contract': 'W2-Contract',
                  'W2-Permanent': 'W2-Permanent',
                  '1099-Contract': '1099-Contract',
                  'H1B Transfer': 'H1B Transfer',
                }}
                title="Preferred Employment Type"
              />

              <CheckboxListFilter
                name="usExperiences"
                options={{
                  Any: 'Any',
                  Junior: 'Junior',
                  Middle: 'Middle',
                  Senior: 'Senior',
                  Architect: 'Architect',
                }}
                title="US Experience"
              />
              <CheckboxListFilter
                name="domainExposures"
                options={{
                  'IT/Software': 'IT/Software',
                  'Dot Com': 'Dot Com',
                  Finance: 'Finance',
                  Insurance: 'Insurance',
                  Government: 'Government',
                  Pharmaceuticals: 'Pharmaceuticals',
                  Healthcare: 'Healthcare',
                  Manufacturing: 'Manufacturing',
                  Retail: 'Retail',
                  Telecom: 'Telecom',
                }}
                title="Domain Exposure "
              />
            </List>
          </Box>
          <DrawerFooter>
            <Stack p={1} spacing={2} direction="row">
              <WsButton variant="outlined" size="large" type="reset">
                Reset
              </WsButton>
              <WsButton variant="contained" size="large" type="submit">
                Apply
              </WsButton>
            </Stack>
          </DrawerFooter>
        </Box>
      </WsDrawer>
    </FormProvider>
  );
};

export default AdvanceFilter;
